module.exports = __webpack_public_path__ + "static/media/Lato-Black.f80bda6a.woff";